import React, {
  createContext,
  useContext,
  useState,
  ReactNode,
  useEffect,
  useRef,
} from "react";
import Cookies from "js-cookie";
import {
  cacheuserdata,
  handleUpdatewatch,
  checkToken,
} from "../services/apicall.tsx";
import { Statescontex } from ".";
import { IUser, ISubscription } from "../devdata/constants/interfaces.tsx";
import {
  updateSta,
  loadSta,
  deleteSta,
} from "../devdata/constants/session.tsx";
interface UserContextType {
  pendingveri: any;
  isloggedin: boolean;
  userdetails: undefined | IUser;
  userToken: string;
  daystocks: [string];
  dhanToken: string;
  isDhanLogged: boolean;
  sub: ISubscription | undefined;
  setdaystocks: (val: [string]) => void;
  setuserToken: (val: string) => void;
  setuser: (val: IUser) => void;
  setsub: (val: ISubscription) => void;
  setpendingveri: (val: []) => void;
  setlogin: (val: boolean) => void;
  setIsDhanLogged: (val: boolean) => void;
  setdhanToken: (val: string) => void;
  loadState: () => void;
  deleteState: () => void;
  updateState: (val: IUser) => void;
}

const UserContext = createContext<UserContextType | undefined>(undefined);
export const UserProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [pendingveri, setpendingveri] = useState([]);
  const [isloggedin, setlogin] = useState(false);
  const [userdetails, setuser] = useState<IUser>();
  const [userToken, setuserToken] = useState("");
  const [isloading, setloading] = useState(false);
  const intervalRef1 = useRef(null);
  const [sub, setsub] = useState<ISubscription>();
  const { setErrorMessage, setErrorshow } = Statescontex();
  const [daystocks, setdaystocks] = useState([]);
  const [isDhanLogged, setIsDhanLogged] = useState(false)
  const [dhanToken, setdhanToken] = useState("")

  const updateState = (val: IUser) => {
    updateSta(val, setuser);
  };
  const getfromcookie = () => {
    try {
      const token = Cookies.get("token");
      if (!!token) {
        setuserToken(token);
      }
    } catch (e) {
      console.log("Token nai hai bhai");
    }
  };

  useEffect(() => {
    if (
      userToken !== "" &&
      userToken !== "loggedout" &&
      userToken !== "Expired" &&
      !isloggedin
    ) {
      checkToken(
        userToken,
        setloading,
        setuserToken,
        setlogin,
        setErrorMessage,
        setErrorshow
      );
    }
  }, [userToken]);

  useEffect(() => {
    if (isloggedin) {
      const fetchData = async () => {
        await Promise.all([
          cacheuserdata(
            userToken,
            setloading,
            setlogin,
            updateState,
            setsub,
            setErrorMessage,
            setErrorshow,
            setdaystocks,
            setIsDhanLogged
          ),
        ]);
      };
      fetchData();

      intervalRef1.current = setInterval(async () => {
        fetchData();
      }, 900000); // Interval set to 30 second (1800000 milliseconds)

      return () => clearInterval(intervalRef1.current);
    }
  }, [isloggedin]);

  useEffect(() => {
    getfromcookie();
    const tokenId = sessionStorage.getItem("tokenId");
    if (tokenId) {
      console.log(tokenId);

      setIsDhanLogged(true)
      setdhanToken(tokenId)
    }
  }, []);
  const loadState = () => {
    loadSta(setuser);
  };
  const deleteState = () => {
    deleteSta(setuser);
  };
  useEffect(() => {
    if (daystocks && isloggedin)
      handleUpdatewatch(
        userToken,
        daystocks,
        updateState,
        setloading,
        setErrorMessage,
        setErrorshow
      );
  }, [daystocks]);

  return (
    <UserContext.Provider
      value={{
        userdetails,
        pendingveri,
        isloggedin,
        userToken,
        sub,
        daystocks,
        isDhanLogged,
        dhanToken,
        setdaystocks,
        setsub,
        setuserToken,
        setuser,
        setpendingveri,
        setlogin,
        loadState,
        deleteState,
        updateState,
        setIsDhanLogged,
        setdhanToken
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export const useUserContext = () => {
  const context = useContext(UserContext);
  if (context === undefined) {
    throw new Error("useUserContext must be used within a UserContextProvider");
  }
  return context;
};
